import {
  GetCreateReservationAvailabilityOptionsQuery,
  GetCreateReservationAvailabilityOptionsQueryVariables
} from '@data/__generated__/types.reservations'
import {gql, useQuery} from 'apollo-hooks'
import dayjs from 'dayjs'

import {useCreateReservationContext} from '../../ReservationContext'

export function useAvailabilityOptions() {
  const {storeOptions, dateHour, partySize, dateDay} = useCreateReservationContext()

  const {data, loading} = useQuery<
    GetCreateReservationAvailabilityOptionsQuery,
    GetCreateReservationAvailabilityOptionsQueryVariables
  >({
    clientName: 'reservations',
    query: gql`
      query getCreateReservationAvailabilityOptions(
        $storeId: String
        $date: Date
        $partySize: Float
      ) {
        sectors: storeSectors(storeId: $storeId) {
          _id
          name
        }
        options: availabilityOptions(storeId: $storeId, date: $date, partySize: $partySize) {
          date
          label
          sectorIds
        }
      }
    `,
    variables: {
      storeId: storeOptions._id,
      date: dateDay,
      partySize
    },
    omit: !storeOptions._id || !dateDay || !partySize,
    fetchPolicy: 'cache-and-network',
    partial: true
  })

  const sectors = data?.sectors ?? []
  let options = data?.options ?? []

  const hour = dateHour
    ? dayjs(dateDay)
        .tz(storeOptions.timezone)
        .hour(Number(dateHour.split(':')[0]))
        .minute(Number(dateHour.split(':')[1]))
    : dayjs().tz(storeOptions.timezone)

  // este filtro que te muestra solo los que estan en un rango similar a 2.5hr se eliminó
  // porque no se entendía bien el rango y se decidió mostrar todos los horarios disponibles
  // options = options.filter(option => {
  //   const diff = dayjs(option.date).tz(storeOptions.timezone).diff(hour, 'minute')
  //   if (Math.abs(diff) > 60 * 2.5) return false
  //   return true
  // })

  while (options.length > 5) {
    const diffToFirst = dayjs(options[0].date).tz(storeOptions.timezone).diff(hour, 'minute')
    const diffToLast = dayjs(options[options.length - 1].date)
      .tz(storeOptions.timezone)
      .diff(hour, 'minute')
    if (Math.abs(diffToFirst) > Math.abs(diffToLast)) {
      options = options.slice(1)
    } else {
      options = options.slice(0, -1)
    }
  }

  return {
    loading,
    options: sectors.map(sector => {
      return {
        sector,
        dates: options.filter(option => option.sectorIds.includes(sector._id))
      }
    })
  }
}
